import { CREATE_FLASH_MESSAGE } from './consts'

export default function createFlashMessage(message, data = {}) {
  const id = crypto.randomUUID()

  return {
    type: CREATE_FLASH_MESSAGE,
    id,
    message,
    data
  }
}
